/**
 * AI Widget control - uses custom events to avoid tight coupling between
 * IntegrationWorkflow and AIAssistant. Dispatch this event to request the
 * AI widget to open (e.g. when user clicks "Ask me").
 */
export const AI_WIDGET_OPEN_EVENT = "ramps:open-ai-widget";

export function requestOpenAIWidget(): void {
	window.dispatchEvent(new CustomEvent(AI_WIDGET_OPEN_EVENT));
}
